function qtyVal(){return parseInt(document.getElementById('qty').value)||1;}
function money(c){var d=c/100; return '$'+(Number.isInteger(d)?d:d.toFixed(2));}
function stepQty(d){var v=Math.max(1,qtyVal()+d);document.getElementById('qty').value=v;
  document.getElementById('orderTotal').textContent=money(CASHE.price*v);}
function addToCart(buyNow){
  if(!CASHE.vid){alert('Create the cashe product in your store first.');return;}
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
    body:JSON.stringify({id:CASHE.vid,quantity:qtyVal()})})
   .then(function(r){return r.json();})
   .then(function(){ if(buyNow){window.location='/checkout';} else {openCart();} })
   .catch(function(){alert('Could not add to cart.');});
}
function openCart(){document.getElementById('cart').classList.add('open');document.getElementById('overlay').classList.add('open');renderCart();}
function closeCart(){document.getElementById('cart').classList.remove('open');document.getElementById('overlay').classList.remove('open');}
function checkout(){window.location='/checkout';}
function renderCart(){
  fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
    document.getElementById('cartCount').textContent=c.item_count;
    var w=document.getElementById('cartItems'), bar=document.getElementById('shipBar');
    if(c.item_count===0){
      w.innerHTML='<div class="cart-empty">Your cart is empty.</div>';
      document.getElementById('cartFoot').style.display='none';
      if(bar){bar.style.display='none';}
      return;
    }
    var h='';
    c.items.forEach(function(i){
      h+='<div class="citem">'
       +'<div class="thumb"><img src="'+(i.image||'')+'" alt="" style="width:100%;height:100%;object-fit:cover"></div>'
       +'<div class="info"><b>'+i.product_title+'</b>'
       +'<div class="citem-qty"><button onclick="changeQty(\''+i.key+'\','+(i.quantity-1)+')">&minus;</button><span>'+i.quantity+'</span><button onclick="changeQty(\''+i.key+'\','+(i.quantity+1)+')">+</button></div>'
       +'<span class="rm" onclick="removeItem(\''+i.key+'\')">Remove</span></div>'
       +'<div class="pr">'+money(i.final_line_price)+'</div></div>';
    });
    w.innerHTML=h;
    document.getElementById('cartSub').textContent=money(c.total_price);
    document.getElementById('cartFoot').style.display='block';
    if(bar){
      var thresh=3500, rem=thresh-c.total_price;
      bar.style.display='block';
      if(rem<=0){document.getElementById('shipMsg').textContent='You unlocked free U.S. shipping';document.getElementById('shipFill').style.width='100%';}
      else{document.getElementById('shipMsg').textContent="You're "+money(rem)+" away from free U.S. shipping";document.getElementById('shipFill').style.width=Math.min(100,c.total_price/thresh*100)+'%';}
    }
  });
}
function removeItem(key){
  fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:0})})
   .then(function(r){return r.json();}).then(function(){renderCart();});
}
function toggleMenu(){document.getElementById('navMenu').classList.toggle('open');}
function setMain(btn){document.getElementById('carMain').src=btn.querySelector('img').src;
  document.querySelectorAll('.thumb-btn').forEach(function(b){b.classList.remove('active');});
  btn.classList.add('active');}
function toggleFaq(btn){var i=btn.parentElement,a=i.querySelector('.faq-a');
  var open=i.classList.toggle('open');a.style.maxHeight=open?a.scrollHeight+'px':0;}
function subscribe(e){e.preventDefault();e.target.querySelector('input').value='';
  e.target.insertAdjacentHTML('afterend','<p style="color:#3c8a60;margin-top:14px;font-size:14px">Thanks! Check your inbox.</p>');return false;}
function changeQty(key,qty){
  if(qty<1){removeItem(key);return;}
  fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})})
   .then(function(r){return r.json();}).then(function(){renderCart();});
}

/* robust mobile autoplay (handles iOS deferred-load + viewport gating) */
function casheKick(){
  document.querySelectorAll('video[autoplay]').forEach(function(v){
    var play=function(){ var p=v.play(); if(p&&p.catch){ p.catch(function(){}); } };
    if(v._cInit){ play(); return; }
    v._cInit=true;
    v.muted=true; v.defaultMuted=true; v.setAttribute('muted','');
    v.playsInline=true; v.setAttribute('playsinline',''); v.setAttribute('webkit-playsinline','');
    v.addEventListener('loadeddata',play);
    v.addEventListener('canplay',play);
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(es){ es.forEach(function(e){
        if(e.isIntersecting){ if(v.readyState<2){ try{ v.load(); }catch(_){ } } play(); }
      }); },{threshold:0.01}).observe(v);
    }
    play();
  });
}
if(document.readyState!=='loading'){ casheKick(); } else { document.addEventListener('DOMContentLoaded',casheKick); }
window.addEventListener('load',casheKick);
['touchstart','pointerdown','scroll'].forEach(function(ev){
  window.addEventListener(ev,function(){ casheKick(); },{passive:true});
});
